import { getDocumentMenu } from './document_menu';

const getMenuItems = async () => {
  const menuItems = {
    items: [await getDocumentMenu()],
    urlMap: {}
  };

  // Initialize urlMap
  menuItems.urlMap = menuItems.items.reduce((map, item) => {
    item.children.forEach((child) => {
      map[child.url] = child;
    });
    return map;
  }, {});
  return menuItems;
};

export { getMenuItems };
